import BeePage from './page.vue'

BeePage.install = (Vue) => {
  Vue.component(BeePage.name, BeePage)
}

export default BeePage



// WEBPACK FOOTER //
// ./src/components/page/index.js